import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useLabelTranslations = () => {
  const { formatMessage } = useIntl();

  const labelTranslations = useMemo(() => {
    return {
      labelName: formatMessage(messages.labelName),
      labelModalityName: formatMessage(messages.labelModalityName),
      labelScanSide: formatMessage(messages.labelScanSide),
      labelDurationMinutes: formatMessage(messages.labelDurationMinutes),
      labelPrice: formatMessage(messages.labelPrice),
      labelDepositAmount: formatMessage(messages.labelDepositAmount),
      labelVisibility: formatMessage(messages.labelVisibility),
      labelRadiologySpeciality: formatMessage(
        messages.labelRadiologySpeciality,
      ),
      labelDescription: formatMessage(messages.labelDescription),
    };
  }, [formatMessage]);

  return labelTranslations;
};

export default useLabelTranslations;
